export const EPSG4326 = {
  name: "EPSG:4326",
  proj4: "",
  wkt: "GCS_WGS_1984",
}